import React from 'react';

import { Promotions } from '@entities/promotions';

const PromotionsPage = () => {
	return <Promotions />;
};

export default PromotionsPage;
